<template>
    <div class="detail-contain">
        <!-- <div class="title">上传{{rectifyStatus === 'guideSuperviseNotice' ? '整改方案' :
          (rectifyStatus === 'guideSupervisePlan'? '整改资料' : '整改通知书')}}</div> -->
        <div class="file-contain">
            <div class="file-title">文件图片</div>
            <div class="img-contain">
                <div class="posting-uploader-item" v-for="(item,nn) in postData" :key="nn">
                    <img :src="item.content" alt="图片" class="imgPreview">
                    <img src="../../assets/guideSystem/delete.png" class="delte" @click="delImg(nn)">
                    <!-- <van-icon name="close" @click="delImg(nn)" class="delte"/> -->
                </div>
                <van-uploader :after-read="onRead" multiple="true" :accept="'image/*'">
                    <!-- <img src="../../assets/guideSystem/ic_upload.png" alt="等待传图" class="imgPreview"> -->
                </van-uploader>
            </div>
        </div>
        <div class="content-contain">
            <div class="content-title">备注说明</div>
                <van-field
                    v-model="message"
                    type="textarea"
                    placeholder="请输入备注说明..."
                    input-class="textarea"
                    :autosize="autoSize"
                />
        </div>
        <div class="btn-box">
            <button class="cancel" :class="canUpload? '' : 'unable'" @click="back">取消</button>
            <button class="submit" :class="canUpload? '' : 'unable'" @click="canUpload? submit() : ''">上传</button>
        </div>
    </div>
</template>
<script>
    import api from '../../service/modules/guide'
    const HTTPS = 'https://'
    export default {
        components: {
        },

        data () {
            return {
                postData: [],
                message: '',
                autoSize: { 'maxHeight': 120, 'minHeight': 120 },
                // cos
                cos: '',
                cosArg: '',
                tempFile: [],
                uploadTemp: [],
                // 上传类型
                rectifyStatus: '',
                // id
                supervisionId: 0
            };
        },

        computed: {
            canUpload () {
                return this.uploadTemp.length > 0 && this.message !== ''
            }
        },

        watch: {},

        methods: {
            onRead (file) { // 上传图片到图片服务器
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                // this.tempFile = file.file
                // this.getSession()
                this.uploadFile()
            },
            delImg (index) {
                // 删除指定下标的图片对象
                if (isNaN(index) || index >= this.postData.length) {
                    return false
                }
                let tmp = []
                for (let i = 0, len = this.postData.length; i < len; i++) {
                    if (this.postData[i] !== this.postData[index]) {
                        tmp.push(this.postData[i])
                    }
                }
                this.postData = tmp
            },
            getSession () {
                api.getCosSession().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                        // this.uploadFile()
                    }
                });
            },
            uploadFile () {
                let cosKey = ''
                console.log('this.tempFile:', this.tempFile)
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log(err, res);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }
            },
            submit () {
                let data = {
                    supervisionId: this.supervisionId,
                    description: this.message,
                    attach: this.uploadTemp.join(',')
                }
                switch (this.rectifyStatus) {
                case 'guideSuperviseNotice':
                    api.rectifyPlan(data).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                    break;
                case 'guideSupervisePlan':
                    api.rectifyMaterial(data).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                    break
                default:
                    api.rectifyNotice(data).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                    break;
                }
            },
            back () {
                this.$router.go(-1);// 返回上一层
            }

        },

        mounted () {
            this.rectifyStatus = this.$route.query.rectifyStatus || ''
            this.supervisionId = this.$route.query.supervisionId || 0
            let title = this.rectifyStatus === 'guideSuperviseNotice' ? '整改方案'
                : (this.rectifyStatus === 'guideSupervisePlan' ? '整改资料' : '整改通知书')
            this.globalApp.setTitle('上传' + title)
            this.getSession()
        },
        created () {}
    }
</script>
<style scoped lang="less">
.detail-contain{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background:rgba(251,251,251,1);
    .title{
        margin-top: 24px;
        margin-left: 12px;
        font-size:16px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:16px;
    }
    .file-contain{
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        .file-title{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
        }
        .img-contain{
            display: flex;
            flex-wrap: wrap;
            margin-top: 13px;
            .posting-uploader-item{
                width: 77px;
                height: 77px;
                position: relative;
                margin-right: 13px;
                margin-bottom: 13px;
                .imgPreview{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .delte{
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: -7px;
                    right: -7px;
                    z-index: 10;
                }
            }
            .van-uploader{
                position: relative;
                top: 0!important;
            }
            .imgPreview{
                width: 77px;
                height: 77px;
            }
        }
    }
    .content-contain{
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        padding: 0 12px;
        margin-bottom: 70px;
        .content-title{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
        }
        .van-cell{
            background:rgba(245,245,245,1);
            border-radius:3px;
            padding: 16px;
            margin-top: 12px;
        }
        .textarea{
            min-height: 400px!important;
        }
        .input-box{
            margin-top: 12px;
        }
    }
    .btn-box{
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 60px;
        background:rgba(255,255,255,1);
        box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
        display: flex;
        padding: 0 15px;
        justify-content: space-between;
        align-items: center;
        .cancel{
            width:165px;
            height:40px;
            background: #ffffff;;
            color: rgba(54,179,116,1);
            border-radius:3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            line-height:16px;
            border: 1px solid rgba(54,179,116,1);
            &.unable{
                width:165px;
                height:40px;
                border-radius:3px;
                border:1px solid rgba(54,179,116,1);
            }
        }
        .submit{
            width:165px;
            height:40px;
            background:rgba(54,179,116,1);
            color: #ffffff;
            border-radius:3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:16px;
            border: 0;
            &.unable{
                background:rgba(54,179,116,0.5);
            }
        }
    }
}
</style>
